import { Link } from 'react-router-dom'
import { MARKT_REF } from '../../hooks/uebersichtRegeln'
import type { AmpelEinschaetzung } from '../../hooks/uebersichtRegeln'
import { zeitKurz } from '../news/newsZeit'
import s from './Marktlage.module.scss'

/**
 * Die Marktlage in einer Zeile: die jüngste Einschätzung über den ganzen
 * Markt. Der Punkt trägt die Ampel, rechts steht, wann sie fiel und wer sie
 * bestätigt hat. Ohne Einschätzung bleibt die Zeile stehen und sagt das.
 *
 * ZWEI ZEILEN, nicht mehr: Die Notiz einer Einschätzung ist auf prod ein
 * ganzer Absatz mit Tatsachen, Chancen, Risiken und Quellen. Hier zählt der
 * erste Satz — der Rest steht hinter dem Klick auf die Einschätzung.
 */
export function Marktlage({ einschaetzung, laedt }: {
  einschaetzung: AmpelEinschaetzung | null
  laedt?: boolean
}) {
  return (
    <section className={s.zeile}>
      <div className={s.marke}>
        <span className={s.punkt} data-rating={einschaetzung?.rating ?? 'none'} aria-hidden="true" />
        <span className={s.label}>Marktlage</span>
      </div>
      {einschaetzung ? (
        <>
          <Link className={s.text} to={`/assessments?ref=${encodeURIComponent(MARKT_REF)}`}
                title={einschaetzung.note ?? undefined}>
            <strong>{einschaetzung.headline.replace(/[.!]?$/, '.')}</strong>
            {einschaetzung.note && <> {einschaetzung.note}</>}
          </Link>
          <div className={s.meta}>
            {zeitKurz(einschaetzung.assessed_at)}
            {einschaetzung.confirmed_at && <> · bestätigt {zeitKurz(einschaetzung.confirmed_at)}</>}
            {' · '}{einschaetzung.source}
          </div>
        </>
      ) : (
        <div className={s.keine}>
          {laedt ? 'sucht …' : 'keine Einschätzung zur Marktlage — eine mit Bezug mkt:IW:GLOBAL erscheint hier.'}
        </div>
      )}
    </section>
  )
}
